import { SAVE_WORKSPACE_TO_STORE, VOTE_THREAD_IN_WORKSPACE } from "./types";

export const saveWorkspaceToStoreAction = (model) => async (dispatch) => {
  dispatch({ type: SAVE_WORKSPACE_TO_STORE, payload: model });
};

export const voteThreadInWorkspaceAction = (model) => async (dispatch) => {
  dispatch({ type: VOTE_THREAD_IN_WORKSPACE, payload: model });
};
